import PropTypes from "prop-types";

// Third party
import moment from "moment";

// Layouts
import ApprovedMessage from "@/Layouts/components/ApprovedMessage";
import { DATE_FORMAT } from "@/Constants/date";

const ApprovedMessageLabel = (props) => {
	const { pdfCompletionDate } = props;
	return (
		<ApprovedMessage
			title={`Signed on ${moment(pdfCompletionDate).format(DATE_FORMAT.usDateTime12hPadded)}`}
			visibility={true}
			titleClassName="washout-approval-page-title"
		/>
	);
};
ApprovedMessageLabel.propTypes = {
	pdfCompletionDate: PropTypes.string,
};

export default ApprovedMessageLabel;
